/**
 * defa.views.SuccessView
 * A context-aware view for showing a success state after a flow.
 * Note, as with more basic views, they use the [SUBJECT + "View"] naming convension, even though they might
 * technically be forms.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/successView.jst.html';

const SuccessView = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	templateContext: function () {
		return {
			context: this.options.context,
			email  : this.options.email || '',
			message: this.options.message || '',
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Triggers the special close event.
	 * @void
	 */
	submit: function () {
		this.trigger( 'success:close', this );
	},
	
} );

export default SuccessView;